import { c as _c } from "react/compiler-runtime";
import { useEffect, useId } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CommunityMemberMinimal } from "@/entities/IProfile";
import CommonProfileSearchItem from "./CommonProfileSearchItem";
import { getSelectableIdentity } from "./getSelectableIdentity";
export default function CommonProfileSearchItems(t0) {
  const $ = _c(6);
  const {
    open,
    profiles,
    selected,
    searchCriteria,
    onProfileSelect,
    highlightedIndex: t1,
    onHighlightedOptionIdChange,
    listboxId
  } = t0;
  const highlightedIndex = t1 === undefined ? null : t1;
  const generatedListboxId = useId();
  const resolvedListboxId = listboxId ?? generatedListboxId;
  let t2;
  if ($[0] !== selected) {
    t2 = selected?.toLowerCase() ?? null;
    $[0] = selected;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const normalizedSelected = t2;
  const buildOptionId = _temp;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (profile_0, index_0) => {
      const optionId = buildOptionId(profile_0, index_0);
      const identity = getSelectableIdentity(profile_0);
      const label = profile_0.display ?? profile_0.handle ?? profile_0.primary_wallet ?? profile_0.wallet ?? `Profile ${index_0 + 1}`;
      return {
        profile: profile_0,
        optionId,
        identity,
        label,
        index: index_0
      };
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const optionMetadata = profiles.map(t3);
  const highlightedOptionId = highlightedIndex !== null && highlightedIndex >= 0 && highlightedIndex < optionMetadata.length ? optionMetadata[highlightedIndex].optionId : undefined;
  useEffect(() => {
    if (!onHighlightedOptionIdChange) {
      return;
    }
    if (!open) {
      onHighlightedOptionIdChange(undefined);
      return;
    }
    onHighlightedOptionIdChange(highlightedOptionId);
  }, [highlightedOptionId, onHighlightedOptionIdChange, open]);
  const noResultsText = !searchCriteria || searchCriteria.length < 3 ? "Type at least 3 characters" : "No results";
  const selectSize = Math.max(Math.min(optionMetadata.length || 1, 10), 1);
  const T0 = AnimatePresence;
  const t4 = "wait";
  const t5 = false;
  const t6 = open && <motion.div className="tw-absolute tw-z-50 tw-mt-1.5 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.2
  }}><div className="tw-absolute tw-overflow-hidden tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-overflow-x-hidden tw-overflow-y-auto"><select id={resolvedListboxId} aria-label="Profile suggestions" tabIndex={-1} size={selectSize} className="tw-sr-only">{optionMetadata.length ? optionMetadata.map(meta => {
            const isOptionSelected = typeof meta.identity === "string" && normalizedSelected === meta.identity.toLowerCase();
            return <option key={`sr-${meta.optionId}`} id={meta.optionId} value={meta.identity ?? meta.optionId} aria-selected={isOptionSelected}>{meta.label}</option>;
          }) : <option id={`${resolvedListboxId}-empty`} value="">{noResultsText}</option>}</select><ul aria-hidden="true" className="tw-flex tw-flex-col tw-gap-y-1 tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{optionMetadata.length ? optionMetadata.map(meta_0 => {
            const isOptionHighlighted = highlightedIndex === meta_0.index;
            return <CommonProfileSearchItem key={meta_0.optionId} id={meta_0.optionId} profile={meta_0.profile} selected={selected} isHighlighted={isOptionHighlighted} onProfileSelect={onProfileSelect} />;
          }) : <li className="tw-py-2 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-text-sm tw-font-medium tw-text-white tw-rounded-lg tw-relative tw-select-none tw-px-2">{noResultsText}</li>}</ul></div></div></motion.div>;
  let t7;
  if ($[3] !== T0 || $[4] !== t6) {
    t7 = <T0 mode={t4} initial={t5}>{t6}</T0>;
    $[3] = T0;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
}
function _temp(profile, index) {
  const rawId = profile.wallet ?? profile.primary_wallet ?? profile.handle ?? profile.display ?? "";
  const sanitized = String(rawId).trim().replaceAll(/[^a-zA-Z0-9_-]+/g, "-").replaceAll(/-+/g, "-").replaceAll(/(^-|-$)/g, "") || "item";
  return `profile-search-item-${sanitized}-${index}`;
}